document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll('.lipss-static-hero');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const wrapper = entry.target;
        if (!wrapper.dataset.animated) {
          wrapper.dataset.animated = 'true';
          startAnimation(wrapper);
        }
      }
    });
  }, { threshold: 0.3 });

  wrappers.forEach(w => observer.observe(w));

  function startAnimation(wrapper) {
    const durationAttr = parseInt(wrapper.dataset.duration, 10);
    const duration = (isNaN(durationAttr) || durationAttr < 1 ? 4 : durationAttr) * 1000;
    const points = wrapper.querySelectorAll('.lsh-point');
    const track = wrapper.querySelector('.lsh-track');
    const itemCount = points.length;

    if (itemCount === 0 || !track) return;

    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      let progress = Math.min(elapsed / duration, 1);

      wrapper.style.setProperty('--progress', progress);

      const trackRect = track.getBoundingClientRect();
      const isVertical = trackRect.height > trackRect.width;
      const trackSize = isVertical ? trackRect.height : trackRect.width;

      if (trackSize > 0) {
        points.forEach((point) => {
          const dot = point.querySelector('.lsh-dot');
          if (!dot) return;

          const dotRect = dot.getBoundingClientRect();
          let dotCenterFromTrackStart = isVertical 
            ? (dotRect.top + dotRect.height / 2) - trackRect.top 
            : (dotRect.left + dotRect.width / 2) - trackRect.left;

          const threshold = Math.max(0, Math.min(1, dotCenterFromTrackStart / trackSize));

          if (progress >= threshold) {
            point.classList.add('is-visible');
          }
        });
      }

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }
});